import api from '../../services/api';

// Action Types
export const INVOICE_NUMBER_MASTER_TYPES = {
  // Fetch actions
  FETCH_INVOICE_NUMBER_MASTERS_REQUEST: 'FETCH_INVOICE_NUMBER_MASTERS_REQUEST',
  FETCH_INVOICE_NUMBER_MASTERS_SUCCESS: 'FETCH_INVOICE_NUMBER_MASTERS_SUCCESS',
  FETCH_INVOICE_NUMBER_MASTERS_FAILURE: 'FETCH_INVOICE_NUMBER_MASTERS_FAILURE',
  
  FETCH_CURRENT_FY_MASTERS_REQUEST: 'FETCH_CURRENT_FY_MASTERS_REQUEST',
  FETCH_CURRENT_FY_MASTERS_SUCCESS: 'FETCH_CURRENT_FY_MASTERS_SUCCESS',
  FETCH_CURRENT_FY_MASTERS_FAILURE: 'FETCH_CURRENT_FY_MASTERS_FAILURE',
  
  FETCH_MASTER_BY_ID_REQUEST: 'FETCH_MASTER_BY_ID_REQUEST',
  FETCH_MASTER_BY_ID_SUCCESS: 'FETCH_MASTER_BY_ID_SUCCESS',
  FETCH_MASTER_BY_ID_FAILURE: 'FETCH_MASTER_BY_ID_FAILURE',
  
  // Create actions
  CREATE_MASTER_REQUEST: 'CREATE_MASTER_REQUEST',
  CREATE_MASTER_SUCCESS: 'CREATE_MASTER_SUCCESS',
  CREATE_MASTER_FAILURE: 'CREATE_MASTER_FAILURE',
  
  // Update actions
  UPDATE_MASTER_REQUEST: 'UPDATE_MASTER_REQUEST',
  UPDATE_MASTER_SUCCESS: 'UPDATE_MASTER_SUCCESS',
  UPDATE_MASTER_FAILURE: 'UPDATE_MASTER_FAILURE',
  
  // Delete actions
  DELETE_MASTER_REQUEST: 'DELETE_MASTER_REQUEST',
  DELETE_MASTER_SUCCESS: 'DELETE_MASTER_SUCCESS',
  DELETE_MASTER_FAILURE: 'DELETE_MASTER_FAILURE',
  
  // Generate next invoice number
  GENERATE_NEXT_INVOICE_NUMBER_REQUEST: 'GENERATE_NEXT_INVOICE_NUMBER_REQUEST',
  GENERATE_NEXT_INVOICE_NUMBER_SUCCESS: 'GENERATE_NEXT_INVOICE_NUMBER_SUCCESS',
  GENERATE_NEXT_INVOICE_NUMBER_FAILURE: 'GENERATE_NEXT_INVOICE_NUMBER_FAILURE',
  // Peek last invoice number (non-increment)
  GET_LAST_INVOICE_NUMBER_REQUEST: 'GET_LAST_INVOICE_NUMBER_REQUEST',
  GET_LAST_INVOICE_NUMBER_SUCCESS: 'GET_LAST_INVOICE_NUMBER_SUCCESS',
  GET_LAST_INVOICE_NUMBER_FAILURE: 'GET_LAST_INVOICE_NUMBER_FAILURE',
  
  // Get current financial year
  GET_CURRENT_FINANCIAL_YEAR_REQUEST: 'GET_CURRENT_FINANCIAL_YEAR_REQUEST',
  GET_CURRENT_FINANCIAL_YEAR_SUCCESS: 'GET_CURRENT_FINANCIAL_YEAR_SUCCESS',
  GET_CURRENT_FINANCIAL_YEAR_FAILURE: 'GET_CURRENT_FINANCIAL_YEAR_FAILURE',
  
  // Clear actions
  CLEAR_MASTER_ERROR: 'CLEAR_MASTER_ERROR',
  CLEAR_MASTER_DATA: 'CLEAR_MASTER_DATA'
};

// Action Creators

// Fetch all invoice number masters
export const fetchInvoiceNumberMasters = (params = {}) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.FETCH_INVOICE_NUMBER_MASTERS_REQUEST });
  
  try {
    const response = await api.get('/invoice-number-masters', { params });
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.FETCH_INVOICE_NUMBER_MASTERS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.FETCH_INVOICE_NUMBER_MASTERS_FAILURE,
      payload: error.response?.data?.message || 'Error fetching invoice number masters'
    });
  }
};

// Fetch current financial year masters
export const fetchCurrentFYInvoiceNumberMasters = () => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.FETCH_CURRENT_FY_MASTERS_REQUEST });
  
  try {
    const response = await api.get('/invoice-number-masters/current-fy');
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.FETCH_CURRENT_FY_MASTERS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.FETCH_CURRENT_FY_MASTERS_FAILURE,
      payload: error.response?.data?.message || 'Error fetching current FY masters'
    });
  }
};

// Fetch master by ID
export const fetchInvoiceNumberMasterById = (id) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.FETCH_MASTER_BY_ID_REQUEST });
  
  try {
    const response = await api.get(`/invoice-number-masters/${id}`);
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.FETCH_MASTER_BY_ID_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.FETCH_MASTER_BY_ID_FAILURE,
      payload: error.response?.data?.message || 'Error fetching invoice number master'
    });
  }
};

// Create invoice number master
export const createInvoiceNumberMaster = (masterData) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.CREATE_MASTER_REQUEST });
  
  try {
    const response = await api.post('/invoice-number-masters', masterData);
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.CREATE_MASTER_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.CREATE_MASTER_FAILURE,
      payload: error.response?.data?.message || 'Error creating invoice number master'
    });
    throw error;
  }
};

// Update invoice number master
export const updateInvoiceNumberMaster = (id, masterData) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.UPDATE_MASTER_REQUEST });
  
  try {
    const response = await api.put(`/invoice-number-masters/${id}`, masterData);
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.UPDATE_MASTER_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.UPDATE_MASTER_FAILURE,
      payload: error.response?.data?.message || 'Error updating invoice number master'
    });
    throw error;
  }
};

// Delete invoice number master
export const deleteInvoiceNumberMaster = (id) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.DELETE_MASTER_REQUEST });
  
  try {
    await api.delete(`/invoice-number-masters/${id}`);
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.DELETE_MASTER_SUCCESS,
      payload: id
    });
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.DELETE_MASTER_FAILURE,
      payload: error.response?.data?.message || 'Error deleting invoice number master'
    });
    throw error;
  }
};

// Generate next invoice number
export const generateNextInvoiceNumber = (category) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GENERATE_NEXT_INVOICE_NUMBER_REQUEST });
  
  try {
    const response = await api.get(`/invoice-number-masters/generate-next/${category}`);
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.GENERATE_NEXT_INVOICE_NUMBER_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.GENERATE_NEXT_INVOICE_NUMBER_FAILURE,
      payload: error.response?.data?.message || 'Error generating next invoice number'
    });
    throw error;
  }
};

// Peek last invoice number (non-incrementing)
export const getLastInvoiceNumber = (category) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_LAST_INVOICE_NUMBER_REQUEST });
  try {
    const response = await api.get(`/invoice-number-masters/last/${category}`);
    dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_LAST_INVOICE_NUMBER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_LAST_INVOICE_NUMBER_FAILURE, payload: error.response?.data?.message || 'Error fetching last invoice number' });
    throw error;
  }
};

// Peek next invoice number (non-incrementing)
export const peekNextInvoiceNumber = (category) => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_LAST_INVOICE_NUMBER_REQUEST });
  try {
    const response = await api.get(`/invoice-number-masters/peek-next/${category}`);
    dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_LAST_INVOICE_NUMBER_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_LAST_INVOICE_NUMBER_FAILURE, payload: error.response?.data?.message || 'Error peeking next invoice number' });
    throw error;
  }
};

// Get current financial year
export const getCurrentFinancialYear = () => async (dispatch) => {
  dispatch({ type: INVOICE_NUMBER_MASTER_TYPES.GET_CURRENT_FINANCIAL_YEAR_REQUEST });
  
  try {
    const response = await api.get('/invoice-number-masters/financial-year');
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.GET_CURRENT_FINANCIAL_YEAR_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: INVOICE_NUMBER_MASTER_TYPES.GET_CURRENT_FINANCIAL_YEAR_FAILURE,
      payload: error.response?.data?.message || 'Error getting current financial year'
    });
    throw error;
  }
};

// Clear error
export const clearInvoiceNumberMasterError = () => ({
  type: INVOICE_NUMBER_MASTER_TYPES.CLEAR_MASTER_ERROR
});

// Clear data
export const clearInvoiceNumberMasterData = () => ({
  type: INVOICE_NUMBER_MASTER_TYPES.CLEAR_MASTER_DATA
});
